import { createAsyncThunk } from '@reduxjs/toolkit';
import { WarehouseClient } from '../../api/Extensions';
import { CommonInfoDto } from '../../api/ClientApi';

export const importCommonInfo = createAsyncThunk<CommonInfoDto>(
    'commonInfo/importCommonInfo',
    async (payload, thunkAPI) => {
        return WarehouseClient.getCommonInfo();
    },
);
